import React from 'react';

const KeyStats = () => {
  const stats = [
    {
      value: '12,400+',
      label: 'Vendors Onboarded',
      description: 'Service providers across all markets',
    },
    {
      value: '847K',
      label: 'Customer Bookings',
      description: 'Completed transactions to date',
    },
    {
      value: '4',
      label: 'Active Markets',
      description: 'Dominican Republic, New York, Puerto Rico, Miami',
    },
    {
      value: '$4.2M',
      label: 'Subscription Revenue',
      description: 'Annual recurring revenue (ARR)',
    },
    {
      value: '$28M',
      label: 'Marketplace Volume',
      description: 'Total GMV processed',
    },
  ];

  return (
    <section className="py-20 bg-primary">
      <div className="max-w-wide mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-sm font-medium text-white/60 uppercase tracking-wider mb-3">
            Platform Metrics
          </p>
          <h2 className="text-display text-white">
            Building at scale
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-4">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center px-4"
            >
              <div className="text-3xl lg:text-4xl font-semibold text-white mb-2">
                {stat.value}
              </div>
              <div className="text-sm font-medium text-white mb-1">
                {stat.label}
              </div>
              <div className="text-xs text-white/50">
                {stat.description}
              </div>
            </div>
          ))}
        </div>

        {/* Live Indicator */}
        <div className="flex items-center justify-center mt-12 text-sm text-white/60">
          <span className="w-2 h-2 bg-accent rounded-full animate-pulse mr-2"></span>
          Data updated in real-time
        </div>
      </div>
    </section>
  );
};

export default KeyStats;
